import * as React from 'react';
import { useSelector } from "react-redux";
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import { selectLoginState } from '../../../features/login/loginSlice';
import { selectRegistrationState } from '../../../features/registration/registrationSlice';
import { selectUtilityState } from '../../../features/utilities/utilitySlice';

export default function CountrySelect({onCountryChange, isNotDisabled} ) {
  const loginSliceState = useSelector(selectLoginState)
  const registrationSliceState = useSelector(selectRegistrationState)
  const utilitySliceState = useSelector(selectUtilityState)
  const handleCountryChange = (event, newValue) => {
    onCountryChange(newValue);
  };

  const nationality = !utilitySliceState.isUanatacaDialogOpen
  ? registrationSliceState.countryCode === 'ALB' ? 'AL' : registrationSliceState.countryCode
  : utilitySliceState.checkFacePhiResponse.nationality
  const defaultValue = !loginSliceState.isManualRegistration ? countries.find((country) => country.code === nationality) : countries.find((country) => country.code === 'AL')

  return (
    <Autocomplete
      id="country-select-demo"
      sx={{ width: 288 }}
      options={countries}
      disabled=
      {
        isNotDisabled ? false :
        (
        !utilitySliceState.isUanatacaDialogOpen 
        ? 
        !loginSliceState.isManualRegistration ? true : false 
        : 
        utilitySliceState.checkFacePhiResponse.nationality !== '' ? true : false)}
      autoHighlight
      getOptionLabel={(option) => option.label}
      onChange={handleCountryChange}
      renderOption={(props, option) => (
        <Box component="li" sx={{ '& > img': { mr: 2, flexShrink: 0 } }} {...props}>
          <img
            loading="lazy"
            width="20"
            srcSet={`https://flagcdn.com/w40/${option.shortCode.toLowerCase()}.png 2x`}
            src={`https://flagcdn.com/w20/${option.shortCode.toLowerCase()}.png`}
            alt=""
          />
          {option.label} ({option.shortCode})
        </Box>
      )}
      renderInput={(params) => (
        <TextField
          {...params}
          label="Zgjidh shtetin"
          color='warning'
          variant='standard'
          inputProps={{
            ...params.inputProps,
            autoComplete: 'new-password', 
          }}
        />
      )}
      defaultValue={defaultValue}
    />
  );
}

const countries = [
  { code: 'AND', shortCode: 'AD', label: 'Andorra' },
  { code: 'ARE', shortCode: 'AE', label: 'United Arab Emirates', phone: '971' },
  { code: 'AFG', shortCode: 'AF', label: 'Afghanistan', phone: '93' },
  { code: 'ATG', shortCode: 'AG', label: 'Antigua and Barbuda', phone: '1-268' },
  { code: 'AIA', shortCode: 'AI', label: 'Anguilla', phone: '1-264' },
  { code: 'AL', shortCode: 'AL', label: 'Albania', phone: '355' },
  { code: 'ARM', shortCode: 'AM', label: 'Armenia', phone: '374' },
  { code: 'AGO', shortCode: 'AO', label: 'Angola', phone: '244' },
  { code: 'ATA', shortCode: 'AQ', label: 'Antarctica', phone: '672' },
  { code: 'ARG', shortCode: 'AR', label: 'Argentina', phone: '54' },
  { code: 'ASM', shortCode: 'AS', label: 'American Samoa', phone: '1-684' },
  { code: 'AUT', shortCode: 'AT', label: 'Austria', phone: '43' },
  { code: 'AUS', shortCode: 'AU', label: 'Australia', phone: '61', suggested: true },
  { code: 'ABW', shortCode: 'AW', label: 'Aruba', phone: '297' },
  { code: 'ALA', shortCode: 'AX', label: 'Alland Islands', phone: '358' },
  { code: 'AZE', shortCode: 'AZ', label: 'Azerbaijan', phone: '994' },
  { code: 'BIH', shortCode: 'BA', label: 'Bosnia and Herzegovina', phone: '387' },
  { code: 'BRB', shortCode: 'BB', label: 'Barbados', phone: '1-246' },
  { code: 'BGD', shortCode: 'BD', label: 'Bangladesh', phone: '880' },
  { code: 'BEL', shortCode: 'BE', label: 'Belgium', phone: '32' },
  { code: 'BFA', shortCode: 'BF', label: 'Burkina Faso', phone: '226' },
  { code: 'BGR', shortCode: 'BG', label: 'Bulgaria', phone: '359' },
  { code: 'BHR', shortCode: 'BH', label: 'Bahrain', phone: '973' },
  { code: 'BDI', shortCode: 'BI', label: 'Burundi', phone: '257' },
  { code: 'BEN', shortCode: 'BJ', label: 'Benin', phone: '229' },
  { code: 'BLM', shortCode: 'BL', label: 'Saint Barthelemy', phone: '590' },
  { code: 'BMU', shortCode: 'BM', label: 'Bermuda', phone: '1-441' },
  { code: 'BRN', shortCode: 'BN', label: 'Brunei Darussalam', phone: '673' },
  { code: 'BOL', shortCode: 'BO', label: 'Bolivia', phone: '591' },
  { code: 'BRA', shortCode: 'BR', label: 'Brazil', phone: '55' },
  { code: 'BHS', shortCode: 'BS', label: 'Bahamas', phone: '1-242' },
  { code: 'BTN', shortCode: 'BT', label: 'Bhutan', phone: '975' },
  { code: 'BVT', shortCode: 'BV', label: 'Bouvet Island', phone: '47' },
  { code: 'BWA', shortCode: 'BW', label: 'Botswana', phone: '267' },
  { code: 'BLR', shortCode: 'BY', label: 'Belarus', phone: '375' },
  { code: 'BLZ', shortCode: 'BZ', label: 'Belize', phone: '501' },
  { code: 'CAN', shortCode: 'CA', label: 'Canada', phone: '1', suggested: true },
  { code: 'CCK', shortCode: 'CC', label: 'Cocos (Keeling) Islands', phone: '61' },
  { code: 'COD', shortCode: 'CD', label: 'Congo, Democratic Republic of the', phone: '243' },
  { code: 'CAF', shortCode: 'CF', label: 'Central African Republic', phone: '236' },
  { code: 'COG', shortCode: 'CG', label: 'Congo, Republic of the', phone: '242' },
  { code: 'CHE', shortCode: 'CH', label: 'Switzerland', phone: '41' },
  { code: 'CIV', shortCode: 'CI', label: "Cote d'Ivoire", phone: '225' },
  { code: 'COK', shortCode: 'CK', label: 'Cook Islands', phone: '682' },
  { code: 'CHL', shortCode: 'CL', label: 'Chile', phone: '56' },
  { code: 'CMR', shortCode: 'CM', label: 'Cameroon', phone: '237' },
  { code: 'CHN', shortCode: 'CN', label: 'China', phone: '86' },
  { code: 'COL', shortCode: 'CO', label: 'Colombia', phone: '57' },
  { code: 'CRI', shortCode: 'CR', label: 'Costa Rica', phone: '506' },
  { code: 'CUB', shortCode: 'CU', label: 'Cuba', phone: '53' },
  { code: 'CPV', shortCode: 'CV', label: 'Cape Verde', phone: '238' },
  { code: 'CUW', shortCode: 'CW', label: 'Curacao', phone: '599' },
  { code: 'CXR', shortCode: 'CX', label: 'Christmas Island', phone: '61' },
  { code: 'CYP', shortCode: 'CY', label: 'Cyprus', phone: '357' },
  { code: 'CZE', shortCode: 'CZ', label: 'Czech Republic', phone: '420' },
  { code: 'DEU', shortCode: 'DE', label: 'Germany', phone: '49', suggested: true },
  { code: 'DJI', shortCode: 'DJ', label: 'Djibouti', phone: '253' },
  { code: 'DNK', shortCode: 'DK', label: 'Denmark', phone: '45' },
  { code: 'DMA', shortCode: 'DM', label: 'Dominica', phone: '1-767' },
  { code: 'DOM', shortCode: 'DO', label: 'Dominican Republic', phone: '1-809' },
  { code: 'DZA', shortCode: 'DZ', label: 'Algeria', phone: '213' },
  { code: 'ECU', shortCode: 'EC', label: 'Ecuador', phone: '593' },
  { code: 'EST', shortCode: 'EE', label: 'Estonia', phone: '372' },
  { code: 'EGY', shortCode: 'EG', label: 'Egypt', phone: '20' },
  { code: 'ESH', shortCode: 'EH', label: 'Western Sahara', phone: '212' },
  { code: 'ERI', shortCode: 'ER', label: 'Eritrea', phone: '291' },
  { code: 'ESP', shortCode: 'ES', label: 'Spain', phone: '34' },
  { code: 'ETH', shortCode: 'ET', label: 'Ethiopia', phone: '251' },
  { code: 'FIN', shortCode: 'FI', label: 'Finland', phone: '358' },
  { code: 'FJI', shortCode: 'FJ', label: 'Fiji', phone: '679' },
  { code: 'FLK', shortCode: 'FK', label: 'Falkland Islands (Malvinas)', phone: '500'},
  { code: 'FSM', shortCode: 'FM', label: 'Micronesia, Federated States of', phone: '691'},
  { code: 'FRO', shortCode: 'FO', label: 'Faroe Islands', phone: '298' },
  { code: 'FRA', shortCode: 'FR', label: 'France', phone: '33', suggested: true },
  { code: 'GAB', shortCode: 'GA', label: 'Gabon', phone: '241' },
  { code: 'GBR', shortCode: 'GB', label: 'United Kingdom', phone: '44' },
  { code: 'GRD', shortCode: 'GD', label: 'Grenada', phone: '1-473' },
  { code: 'GEO', shortCode: 'GE', label: 'Georgia', phone: '995' },
  { code: 'GUF', shortCode: 'GF', label: 'French Guiana', phone: '594' },
  { code: 'GGY', shortCode: 'GG', label: 'Guernsey', phone: '44' },
  { code: 'GHA', shortCode: 'GH', label: 'Ghana', phone: '233' },
  { code: 'GIB', shortCode: 'GI', label: 'Gibraltar', phone: '350' },
  { code: 'GRL', shortCode: 'GL', label: 'Greenland', phone: '299' },
  { code: 'GMB', shortCode: 'GM', label: 'Gambia', phone: '220' },
  { code: 'GIN', shortCode: 'GN', label: 'Guinea', phone: '224' },
  { code: 'GLP', shortCode: 'GP', label: 'Guadeloupe', phone: '590' },
  { code: 'GNQ', shortCode: 'GQ', label: 'Equatorial Guinea', phone: '240' },
  { code: 'GRC', shortCode: 'GR', label: 'Greece', phone: '30' },
  { code: 'SGS', shortCode: 'GS', label: 'South Georgia and the South Sandwich Islands', phone: '500'},
  { code: 'GTM', shortCode: 'GT', label: 'Guatemala', phone: '502' },
  { code: 'GUM', shortCode: 'GU', label: 'Guam', phone: '1-671' },
  { code: 'GNB', shortCode: 'GW', label: 'Guinea-Bissau', phone: '245' },
  { code: 'GUY', shortCode: 'GY', label: 'Guyana', phone: '592' },
  { code: 'HKG', shortCode: 'HK', label: 'Hong Kong', phone: '852' },
  { code: 'HMD', shortCode: 'HM', label: 'Heard Island and McDonald Islands', phone: '672' },
  { code: 'HND', shortCode: 'HN', label: 'Honduras', phone: '504' },
  { code: 'HRV', shortCode: 'HR', label: 'Croatia', phone: '385' },
  { code: 'HTI', shortCode: 'HT', label: 'Haiti', phone: '509' },
  { code: 'HUN', shortCode: 'HU', label: 'Hungary', phone: '36' },
  { code: 'IDN', shortCode: 'ID', label: 'Indonesia', phone: '62' },
  { code: 'IRL', shortCode: 'IE', label: 'Ireland', phone: '353' },
  { code: 'ISR', shortCode: 'IL', label: 'Israel', phone: '972' },
  { code: 'IMN', shortCode: 'IM', label: 'Isle of Man', phone: '44' },
  { code: 'IND', shortCode: 'IN', label: 'India', phone: '91' },
  { code: 'IOT', shortCode: 'IO', label: 'British Indian Ocean Territory', phone: '246' },
  { code: 'IRQ', shortCode: 'IQ', label: 'Iraq', phone: '964' },
  { code: 'IRN', shortCode: 'IR', label: 'Iran, Islamic Republic of', phone: '98' },
  { code: 'ISL', shortCode: 'IS', label: 'Iceland', phone: '354' },
  { code: 'ITA', shortCode: 'IT', label: 'Italy', phone: '39' },
  { code: 'JEY', shortCode: 'JE', label: 'Jersey', phone: '44' },
  { code: 'JAM', shortCode: 'JM', label: 'Jamaica', phone: '1-876' },
  { code: 'JOR', shortCode: 'JO', label: 'Jordan', phone: '962' },
  { code: 'JPN', shortCode: 'JP', label: 'Japan', phone: '81', suggested: true },
  { code: 'KEN', shortCode: 'KE', label: 'Kenya', phone: '254' },
  { code: 'KGZ', shortCode: 'KG', label: 'Kyrgyzstan', phone: '996' },
  { code: 'KHM', shortCode: 'KH', label: 'Cambodia', phone: '855' },
  { code: 'KIR', shortCode: 'KI', label: 'Kiribati', phone: '686' },
  { code: 'COM', shortCode: 'KM', label: 'Comoros', phone: '269' },
  { code: 'KNA', shortCode: 'KN', label: 'Saint Kitts and Nevis', phone: '1-869' },
  { code: 'PRK', shortCode: 'KP', label: "Korea, Democratic People's Republic of", phone: '850' },
  { code: 'KOR', shortCode: 'KR', label: 'Korea, Republic of', phone: '82' },
  { code: 'KWT', shortCode: 'KW', label: 'Kuwait', phone: '965' },
  { code: 'CYM', shortCode: 'KY', label: 'Cayman Islands', phone: '1-345' },
  { code: 'KAZ', shortCode: 'KZ', label: 'Kazakhstan', phone: '7' },
  { code: 'LAO', shortCode: 'LA', label: "Lao People's Democratic Republic", phone: '856' },
  { code: 'LBN', shortCode: 'LB', label: 'Lebanon', phone: '961' },
  { code: 'LCA', shortCode: 'LC', label: 'Saint Lucia', phone: '1-758' },
  { code: 'LIE', shortCode: 'LI', label: 'Liechtenstein', phone: '423' },
  { code: 'LKA', shortCode: 'LK', label: 'Sri Lanka', phone: '94' },
  { code: 'LBR', shortCode: 'LR', label: 'Liberia', phone: '231' },
  { code: 'LSO', shortCode: 'LS', label: 'Lesotho', phone: '266' },
  { code: 'LTU', shortCode: 'LT', label: 'Lithuania', phone: '370' },
  { code: 'LUX', shortCode: 'LU', label: 'Luxembourg', phone: '352' },
  { code: 'LVA', shortCode: 'LV', label: 'Latvia', phone: '371' },
  { code: 'LBY', shortCode: 'LY', label: 'Libya', phone: '218' },
  { code: 'MAR', shortCode: 'MA', label: 'Morocco', phone: '212' },
  { code: 'MCO', shortCode: 'MC', label: 'Monaco', phone: '377' },
  { code: 'MDA', shortCode: 'MD', label: 'Moldova, Republic of', phone: '373' },
  { code: 'MNE', shortCode: 'ME', label: 'Montenegro', phone: '382' },
  { code: 'MAF', shortCode: 'MF', label: 'Saint Martin (French part)', phone: '590' },
  { code: 'MDG', shortCode: 'MG', label: 'Madagascar', phone: '261' },
  { code: 'MHL', shortCode: 'MH', label: 'Marshall Islands', phone: '692' },
  { code: 'MKD', shortCode: 'MK', label: 'Macedonia, the Former Yugoslav Republic of', phone: '389' },
  { code: 'MLI', shortCode: 'ML', label: 'Mali', phone: '223' },
  { code: 'MMR', shortCode: 'MM', label: 'Myanmar', phone: '95' },
  { code: 'MNG', shortCode: 'MN', label: 'Mongolia', phone: '976' },
  { code: 'MAC', shortCode: 'MO', label: 'Macao', phone: '853' },
  { code: 'MNP', shortCode: 'MP', label: 'Northern Mariana Islands', phone: '1-670' },
  { code: 'MTQ', shortCode: 'MQ', label: 'Martinique', phone: '596' },
  { code: 'MRT', shortCode: 'MR', label: 'Mauritania', phone: '222' },
  { code: 'MSR', shortCode: 'MS', label: 'Montserrat', phone: '1-664' },
  { code: 'MLT', shortCode: 'MT', label: 'Malta', phone: '356' },
  { code: 'MUS', shortCode: 'MU', label: 'Mauritius', phone: '230' },
  { code: 'MDV', shortCode: 'MV', label: 'Maldives', phone: '960' },
  { code: 'MWI', shortCode: 'MW', label: 'Malawi', phone: '265' },
  { code: 'MEX', shortCode: 'MX', label: 'Mexico', phone: '52' },
  { code: 'MYS', shortCode: 'MY', label: 'Malaysia', phone: '60' },
  { code: 'MOZ', shortCode: 'MZ', label: 'Mozambique', phone: '258' },
  { code: 'NAM', shortCode: 'NA', label: 'Namibia', phone: '264' },
  { code: 'NCL', shortCode: 'NC', label: 'New Caledonia', phone: '687' },
  { code: 'NER', shortCode: 'NE', label: 'Niger', phone: '227' },
  { code: 'NFK', shortCode: 'NF', label: 'Norfolk Island', phone: '672' },
  { code: 'NGA', shortCode: 'NG', label: 'Nigeria', phone: '234' },
  { code: 'NIC', shortCode: 'NI', label: 'Nicaragua', phone: '505' },
  { code: 'NLD', shortCode: 'NL', label: 'Netherlands', phone: '31' },
  { code: 'NOR', shortCode: 'NO', label: 'Norway', phone: '47' },
  { code: 'NPL', shortCode: 'NP', label: 'Nepal', phone: '977' },
  { code: 'NRU', shortCode: 'NR', label: 'Nauru', phone: '674' },
  { code: 'NIU', shortCode: 'NU', label: 'Niue', phone: '683' },
  { code: 'NZL', shortCode: 'NZ', label: 'New Zealand', phone: '64' },
  { code: 'OMN', shortCode: 'OM', label: 'Oman', phone: '968' },
  { code: 'PAK', shortCode: 'PK', label: 'Pakistan', phone: '92' },
  { code: 'PAN', shortCode: 'PA', label: 'Panama', phone: '507' },
  { code: 'PER', shortCode: 'PE', label: 'Peru', phone: '51' },
  { code: 'PYF', shortCode: 'PF', label: 'French Polynesia', phone: '689' },
  { code: 'PNG', shortCode: 'PG', label: 'Papua New Guinea', phone: '675' },
  { code: 'PHL', shortCode: 'PH', label: 'Philippines', phone: '63' },
  { code: 'POL', shortCode: 'PL', label: 'Poland', phone: '48' },
  { code: 'SPM', shortCode: 'PM', label: 'Saint Pierre and Miquelon', phone: '508' },
  { code: 'PCN', shortCode: 'PN', label: 'Pitcairn', phone: '870' },
  { code: 'PRI', shortCode: 'PR', label: 'Puerto Rico', phone: '1' },
  { code: 'PSE', shortCode: 'PS', label: 'Palestine, State of', phone: '970' },
  { code: 'PRT', shortCode: 'PT', label: 'Portugal', phone: '351' },
  { code: 'PLW', shortCode: 'PW', label: 'Palau', phone: '680' },
  { code: 'PRY', shortCode: 'PY', label: 'Paraguay', phone: '595' },
  { code: 'QAT', shortCode: 'QA', label: 'Qatar', phone: '974' },
  { code: 'REU', shortCode: 'RE', label: 'Reunion', phone: '262' },
  { code: 'ROU', shortCode: 'RO', label: 'Romania', phone: '40' },
  { code: 'SRB', shortCode: 'RS', label: 'Serbia', phone: '381' },
  { code: 'RUS', shortCode: 'RU', label: 'Russian Federation', phone: '7' },
  { code: 'RWA', shortCode: 'RW', label: 'Rwanda', phone: '250' },
  { code: 'SAU', shortCode: 'SA', label: 'Saudi Arabia', phone: '966' },
  { code: 'SLB', shortCode: 'SB', label: 'Solomon Islands', phone: '677' },
  { code: 'SYC', shortCode: 'SC', label: 'Seychelles', phone: '248' },
  { code: 'SDN', shortCode: 'SD', label: 'Sudan', phone: '249' },
  { code: 'SWE', shortCode: 'SE', label: 'Sweden', phone: '46' },
  { code: 'SGP', shortCode: 'SG', label: 'Singapore', phone: '65' },
  { code: 'SHN', shortCode: 'SH', label: 'Saint Helena', phone: '290' },
  { code: 'SVN', shortCode: 'SI', label: 'Slovenia', phone: '386' },
  { code: 'SJM', shortCode: 'SJ', label: 'Svalbard and Jan Mayen', phone: '47' },
  { code: 'SVK', shortCode: 'SK', label: 'Slovakia', phone: '421' },
  { code: 'SLE', shortCode: 'SL', label: 'Sierra Leone', phone: '232' },
  { code: 'SMR', shortCode: 'SM', label: 'San Marino', phone: '378' },
  { code: 'SEN', shortCode: 'SN', label: 'Senegal', phone: '221' },
  { code: 'SOM', shortCode: 'SO', label: 'Somalia', phone: '252' },
  { code: 'SUR', shortCode: 'SR', label: 'Suriname', phone: '597' },
  { code: 'SSD', shortCode: 'SS', label: 'South Sudan', phone: '211' },
  { code: 'STP', shortCode: 'ST', label: 'Sao Tome and Principe', phone: '239' },
  { code: 'SLV', shortCode: 'SV', label: 'El Salvador', phone: '503' },
  { code: 'SXM', shortCode: 'SX', label: 'Sint Maarten (Dutch part)', phone: '1-721' },
  { code: 'SYR', shortCode: 'SY', label: 'Syrian Arab Republic', phone: '963' },
  { code: 'SWZ', shortCode: 'SZ', label: 'Swaziland', phone: '268' },
  { code: 'TCA', shortCode: 'TC', label: 'Turks and Caicos Islands', phone: '1-649' },
  { code: 'TCD', shortCode: 'TD', label: 'Chad', phone: '235' },
  { code: 'ATF', shortCode: 'TF', label: 'French Southern Territories', phone: '262' },
  { code: 'TGO', shortCode: 'TG', label: 'Togo', phone: '228' },
  { code: 'THA', shortCode: 'TH', label: 'Thailand', phone: '66' },
  { code: 'TJK', shortCode: 'TJ', label: 'Tajikistan', phone: '992' },
  { code: 'TKL', shortCode: 'TK', label: 'Tokelau', phone: '690' },
  { code: 'TLS', shortCode: 'TL', label: 'Timor-Leste', phone: '670' },
  { code: 'TKM', shortCode: 'TM', label: 'Turkmenistan', phone: '993' },
  { code: 'TUN', shortCode: 'TN', label: 'Tunisia', phone: '216' },
  { code: 'TON', shortCode: 'TO', label: 'Tonga', phone: '676' },
  { code: 'TUR', shortCode: 'TR', label: 'Turkey', phone: '90' },
  { code: 'TTO', shortCode: 'TT', label: 'Trinidad and Tobago', phone: '1-868' },
  { code: 'TUV', shortCode: 'TV', label: 'Tuvalu', phone: '688' },
  { code: 'TWN', shortCode: 'TW', label: 'Taiwan', phone: '886' },
  { code: 'TZA', shortCode: 'TZ', label: 'United Republic of Tanzania', phone: '255' },
  { code: 'UKR', shortCode: 'UA', label: 'Ukraine', phone: '380' },
  { code: 'UGA', shortCode: 'UG', label: 'Uganda', phone: '256' },
  { code: 'USA', shortCode: 'US', label: 'United States', phone: '1', suggested: true },
  { code: 'URY', shortCode: 'UY', label: 'Uruguay', phone: '598' },
  { code: 'UZB', shortCode: 'UZ', label: 'Uzbekistan', phone: '998' },
  { code: 'VAT', shortCode: 'VA', label: 'Holy See (Vatican City State)', phone: '379' },
  { code: 'VCT', shortCode: 'VC', label: 'Saint Vincent and the Grenadines', phone: '1-784' },
  { code: 'VEN', shortCode: 'VE', label: 'Venezuela', phone: '58' },
  { code: 'VGB', shortCode: 'VG', label: 'British Virgin Islands', phone: '1-284' },
  { code: 'VIR', shortCode: 'VI', label: 'US Virgin Islands', phone: '1-340' },
  { code: 'VNM', shortCode: 'VN', label: 'Vietnam', phone: '84' },
  { code: 'VUT', shortCode: 'VU', label: 'Vanuatu', phone: '678' },
  { code: 'WLF', shortCode: 'WF', label: 'Wallis and Futuna', phone: '681' },
  { code: 'WSM', shortCode: 'WS', label: 'Samoa', phone: '685' },
  { code: 'XKX', shortCode: 'XK', label: 'Kosovo', phone: '383' },
  { code: 'YEM', shortCode: 'YE', label: 'Yemen', phone: '967' },
  { code: 'MYT', shortCode: 'YT', label: 'Mayotte', phone: '262' },
  { code: 'ZAF', shortCode: 'ZA', label: 'South Africa', phone: '27' },
  { code: 'ZMB', shortCode: 'ZM', label: 'Zambia', phone: '260' },
  { code: 'ZWE', shortCode: 'ZW', label: 'Zimbabwe', phone: '263' },
];
